module.exports = __webpack_public_path__ + "static/media/pic2.3f66442c.jpg";